class desktopFeatures {
	constructor() {
		this.options = {
			paths: '#pentagon-path',
			pointsNumber: 15,
			maxDistance: 4000,
			color: 'transparent',
			centroid: '.centroid-text',
			border: '#fff',
			borderWidth: 2,
		}
		this.hoverIndex = 1;
	}
	jelly() {
		const template = `
			<svg viewBox="0 0 200 200" style="display: none;">
				<path id="pentagon-path" d="M100 166C136.451 166 166 136.451 166 100C166 63.5492 136.451 34 100 34C63.5492 34 34 63.5492 34 100C34 136.451 63.5492 166 100 166ZM100 168C137.555 168 168 137.555 168 100C168 62.4446 137.555 32 100 32C62.4446 32 32 62.4446 32 100C32 137.555 62.4446 168 100 168Z"/>
			</svg>
			<div class="jelly-container">
				<!-- Canvas to draw the jelly pentagon -->
				<canvas class="jelly-canvas"></canvas>

				<!-- Text in the centroid of the jelly pentagon -->
				<div class="centroid-container">
					<div class="centroid-text"></div>
				</div>
			</div>

			<div id="dote"></div>
		`
		document.querySelector('footer').insertAdjacentHTML('afterend', template)

		const jelly = new Jelly('.jelly-canvas', this.options);
		let startX, startY, dx, dy, endX = 0,
		  endY = 0,
		  x = 0,
		  y = 0,
		  lastX = 0,
		  lastY = 0;
		let down = false;

	let shakeLimit = 1;

	const container = document.querySelector('.jelly-container');
	const dot = document.querySelector('#dote')
	const centroid_text = document.querySelector('.centroid-text')

	const cases = document.querySelectorAll('.cases')[0]
	const about = document.querySelectorAll('.about')[0]
	const pfitems = document.querySelectorAll('.portfolio-item')

	let offset = {
	  x: 90,
	  y: 90
	}

	window.addEventListener('load', () => {
	  let tween = new TweenMax(container, 0, {
		scale: 0.35
	  })
	}, false)

	document.addEventListener('mouseleave', function(e) {
	  TweenMax.to(container, .4, {
		opacity: 0,
	  })
	  TweenMax.to(dot, .4, {
		opacity: 0,
	  })
	}, false)

	document.addEventListener('mouseenter', function(e) {
	  TweenMax.to(container, .4, {
		opacity: 1,
	  })
	  TweenMax.to(dot, .4, {
		opacity: 1,
	  })
	}, false)

	document.addEventListener('mousemove', function(e) {
	  startX = window.innerWidth / 2;
	  startY = window.innerHeight / 2;
	  TweenMax.to(dot, .1, {
		x: e.clientX - 5,
		y: e.clientY - 5
	  })
	  x = e.clientX - startX;
	  y = e.clientY - startY;
	  TweenMax.to(container, .4, {
		x: e.clientX - offset.x,
		y: e.clientY - offset.y
	  })

	  dx = x - lastX;
	  dy = y - lastY;
	  if (dx > shakeLimit || dx < -shakeLimit) dx = dx < 0 ? -shakeLimit : shakeLimit;
	  if (dy > shakeLimit || dy < -shakeLimit) dy = dy < 0 ? -shakeLimit : shakeLimit;
	  jelly.shake({
		x: -dx,
		y: -dy
	  });
	  lastX = x;
	  lastY = y;
	});

	function customCursor(e, container, dot, text, offsets) {
	  TweenMax.to(container.el, container.dur, {
		scale: container.scale
	  })
	  TweenMax.to(dot.el, dot.dur, {
		scale: dot.scale
	  })
	  centroid_text.textContent = text

	  offset.x = offsets.x
	  offset.y = offsets.y
	}

	function addMamamia(item, parr) {
	  let parallaxInstance = new Parallax(item);
	}
	let paralaxarr = []

	if (pfitems.length > 0) {
	  for (let i = 0; i < pfitems.length; i++) {
		pfitems[i].addEventListener('mousemove', function(e) {
		  customCursor(e, {
			  el: container,
			  scale: 1,
			  dur: .3
			}, {
			  el: dot,
			  scale: 0,
			  dur: .3
			},
			'view', {
			  x: 98,
			  y: 105
			})
		}, false)
		pfitems[i].addEventListener('mouseenter', function(e) {
		  pfitems[i].querySelector('.paralax-pf').setAttribute('data-depth', 2)
		  let parallaxInstance = new Parallax(pfitems[i]);
		  paralaxarr.push(parallaxInstance)
		}, false)
		pfitems[i].addEventListener('mouseleave', function(e) {
		  pfitems[i].querySelector('.paralax-pf').style.transform = 'translate3d(0,0,0)'
		  paralaxarr[0].disable()
		  for (let p of paralaxarr) {
			p.disable()
		  }

		  customCursor(e, {
			el: container,
			scale: 0.35,
			dur: .3
		  }, {
			el: dot,
			scale: 1,
			dur: .3
		  }, '', {
			x: 90,
			y: 90
		  })
		}, false)

		// pg paralax
		const parr = pfitems[i]
	  }
	}
	if (cases && about) {
	  cases.addEventListener('mousemove', function(e) {
		customCursor(e, {
			el: container,
			scale: 1,
			dur: .3
		  }, {
			el: dot,
			scale: 0,
			dur: .3
		  },
		  'portfolio', {
			x: 98,
			y: 105
		  })
	  }, false)
	  about.addEventListener('mousemove', function(e) {
		customCursor(e, {
		  el: container,
		  scale: 1,
		  dur: .3
		}, {
		  el: dot,
		  scale: 0,
		  dur: .3
		}, 'agency', {
		  x: 98,
		  y: 105
		})
	  }, false)
	  cases.addEventListener('mouseleave', function(e) {
		customCursor(e, {
		  el: container,
		  scale: 0.35,
		  dur: .3
		}, {
		  el: dot,
		  scale: 1,
		  dur: .3
		}, '', {
		  x: 90,
		  y: 90
		})
	  }, false)

	  about.addEventListener('mouseleave', function(e) {
		customCursor(e, {
		  el: container,
		  scale: 0.35,
		  dur: .3
		}, {
		  el: dot,
		  scale: 1,
		  dur: .3
		}, '', {
		  x: 90,
		  y: 90
		})

	  }, false)

	}
	const links_list = document.querySelectorAll('a')

	links_list.forEach(link => {
	  if (!link.classList.contains('cases') && !link.classList.contains('about')) {
		link.addEventListener('mouseenter', function(e) {
		  customCursor(e, {
			el: container,
			scale: 0.6,
			dur: .2
		  }, {
			el: dot,
			scale: 1,
			dur: .3
		  }, '', {
			x: 95,
			y: 95
		  })

		}, false)
		link.addEventListener('mouseleave', function(e) {
		  customCursor(e, {
			el: container,
			scale: 0.35,
			dur: .2
		  }, {
			el: dot,
			scale: 1,
			dur: .3
		  }, '', {
			x: 90,
			y: 90
		  })

		}, false)
	  }
	})
  }

};

const cursor = new desktopFeatures()

if (window.innerWidth >= 768) {
	cursor.jelly()
}

// popup
const popup_found = document.querySelectorAll('[data-modal]')
const targets = document.querySelectorAll('[data-target]')
let targets_array = []
if (popup_found.length > 0) {
  let data;
  for (let item of popup_found) {
	item.addEventListener('click', function(e) {
	  e.preventDefault()
	  e.stopPropagation()

	  for (let t = 0; t < targets.length; t++) {
		if (this.getAttribute('data-modal') == targets[t].getAttribute('data-target')) {
		  targets_array.push(targets[t])
		}
		targets[t].classList.remove('view')
	  }

	  for (let a = 0; a < targets_array.length; a++) {
		targets_array[a].classList.toggle('view')
	  }
	}, false)
  }
} []

if (document.getElementById("textdisplay")) {
  function updateAgency() {
	//Manages updating the circle's text and size.
	document.getElementById("textdisplay").textContent = document.getElementById("textdisplay").textContent;
	sizeCircleToText(document.getElementById("pathoptions"),
	  document.getElementById("svgmain"),
	  document.getElementById("textdisplay"),
	  7); //Magic number, need a way to measure total physical length of chars
  };

  function sizeCircleToText(pathObject, targetSVG, targetText, charWidth) {
	//Calcs the circumference of the circle needed and applies it.
	r = (targetText.innerHTML.length * charWidth); //Radius
	//r = (targetText.getComputedTextLength()+1)/6; //Maybe?
	d = (r * 2); //diameter
	path = "M" + (d) + "," + (d) + "m " + (-r) + ",0 a " + (r) + "," + (r) + " 0 1,1 " + (d) + ",0 a " + r + "," + r + " 0 1,1 " + (-d) + ",0"; //This gibberish is the path construction for a circle. Better way to do this or concat all this?
	viewBox = "0 0 " + d * 2 + " " + d * 2; //The viewbox rect
	pathObject.setAttribute("d", path);
	targetSVG.setAttribute("viewBox", viewBox);
  }
  updateAgency();
}